const corporationOptionsCallback = {
  httpMethod: 'POST',
  route: 'corporations/read',
  generateBody: (searchTerm) => ({
    filters: searchTerm ? [{ operation: 'icontains', field: 'name', value: searchTerm }] : [],
  }),
};

export default corporationOptionsCallback;
